
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import TabContent from "../tabs/TabContent";

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (value: string) => void;
}

const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  return (
    <Tabs 
      value={activeTab} 
      onValueChange={onTabChange}
      className="mb-8"
    >
      <TabsList className="grid w-full grid-cols-6 max-w-[1200px] mx-auto mb-6">
        <TabsTrigger value="integrations">Integrations</TabsTrigger>
        <TabsTrigger value="alerts">Alerts</TabsTrigger>
        <TabsTrigger value="presets">Graph Presets</TabsTrigger>
        <TabsTrigger value="standards">Standards</TabsTrigger>
        <TabsTrigger value="bpa">BPA Templates</TabsTrigger>
        <TabsTrigger value="licenses">License Helper</TabsTrigger>
      </TabsList>

      <div className="bg-black/20 backdrop-blur-sm rounded-lg border border-white/5 overflow-hidden">
        <TabContent tabName={activeTab} />
      </div>
    </Tabs>
  );
};

export default TabNavigation;
